import ResultCompoundImages from './ResultCompoundImages';
import ResultInfo from './ResultInfo';
import { useDispatch } from 'react-redux';
import SahelModal from '../common/SahelModal';
import {
  setFirstDestination,
  setSecondDestination
} from '../../../../redux/slices/mapSlice';

const DistanceResultModal = () => {
  const dispatch = useDispatch();

  const closeDrawer = () => {
    dispatch(setFirstDestination(null));
    dispatch(setSecondDestination(null));
  };

  return (
    <SahelModal handleClose={closeDrawer} isOnboarding={false}>
      <ResultCompoundImages />

      <ResultInfo />
    </SahelModal>
  );
};

export default DistanceResultModal;
